import {toast} from 'sonner';
import {getErrorMessage} from './getErrorMessage';
import i18next from 'i18next';

export function addSupportEmailToMessage(message?: string, prefixText?: string) {
  if (typeof message !== 'string') {
    return message;
  }

  const builtMessage = `${prefixText ? `${prefixText} ` : ''}${message}`;

  return (
    <div>
      <div>{builtMessage}</div>
      {i18next.t('reach_us_at_email')}
    </div>
  );
}

type CustomToastOptions = {
  autoClose?: number;
  prefixText?: string;
};

function toastResponseError(error: unknown, options: CustomToastOptions = {}) {
  const message =
    typeof error === 'string'
      ? error
      : addSupportEmailToMessage(getErrorMessage(error), options?.prefixText);

  const toastId =
    (error as Error)?.message || (typeof error === 'string' && error) || 'toastId';

  toast.error(message, {
    id: toastId,
    duration: options?.autoClose || Infinity,
    ...options,
  });
}

export {toastResponseError};
